import Marquee from "react-fast-marquee";

const items = ["HAMPTONS", "MANHATTAN", "JFK", "LAGUARDIA", "NEWARK", "MONTAUK", "TETERBORO"];

export const Ribbon = () => (
  <div className="border-y border-white/10 bg-ink py-6" data-testid="editorial-ribbon">
    <Marquee speed={30} gradient={false} autoFill>
      {items.map((t, i) => (
        <span key={i} className="mx-10 font-serif text-3xl lg:text-4xl text-[#8A8A8A] tracking-wide flex items-center gap-10">
          {t} <span className="text-gold text-lg">✦</span>
        </span>
      ))}
    </Marquee>
  </div>
);

export default Ribbon;
